import { useLayoutEffect, useState } from 'react';

// Measured before paint, so the first frame already has the height.
export function useElementHeight() {
  const [node, setNode] = useState<HTMLElement | null>(null);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    if (!node) return;
    setHeight(node.offsetHeight);
    // Rounded here so a sub-pixel change gives an equal value and no re-render.
    const observer = new ResizeObserver(([entry]) =>
      setHeight(
        Math.round(
          entry.borderBoxSize?.[0]?.blockSize ?? entry.contentRect.height
        )
      )
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [node]);

  return [setNode, height] as const;
}
